import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { scrollBar } from 'styles/theme'
import CopilotSettings from './CopilotSettings/CopilotSettings'
import CopilotInsights from './CopilotInsights/CopilotInsights'
import PatientCopilotNeedsAttentionWidget from './NeedsAttention/PatientCopilotNeedsAttentionWidget'
import useLoadPatientFromUrlParams from 'components/Patients/useLoadPatientFromUrlParams'

const useStyles = makeStyles(theme => ({
  patientCopilotRoot: {
    background: 'white',
    height: '100%',
    overflowY: 'scroll',
    padding: '20px 24px',
    // Tighter padding on phones so cards / widgets don't get squeezed to ~280px wide.
    [theme.breakpoints.down('xs')]: {
      padding: '12px'
    },
    ...scrollBar
  }
}))

const PatientCopilot = () => {
  const classes = useStyles()

  const { patient } = useLoadPatientFromUrlParams({})
  const analyticsPayload = {
    patientId: patient?.id
  }

  return (
    <div className={classes.patientCopilotRoot}>
      <PatientCopilotNeedsAttentionWidget />
      <CopilotSettings analyticsPayload={analyticsPayload} />
      <div style={{ marginTop: 20 }}>
        <CopilotInsights />
      </div>
    </div>
  )
}

export default PatientCopilot
